import classroom from "./classroom";
import login from "./login";
import hometraining from "./hometraining";
import admin from "./admin"

export default { ...classroom, ...login, ...hometraining, ...admin };
